import { render, staticRenderFns } from "./AddCurrency.vue?vue&type=template&id=24579194&scoped=true"
import script from "./AddCurrency.vue?vue&type=script&lang=js"
export * from "./AddCurrency.vue?vue&type=script&lang=js"
import style0 from "./AddCurrency.vue?vue&type=style&index=0&id=24579194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24579194",
  null
  
)

export default component.exports